(function () {
  function init(root) {
    if (!root || root.dataset.rmdsExistingPickerInit === 'true') return;
    root.dataset.rmdsExistingPickerInit = 'true';

    const productContainer = root.closest('[data-section-id]') || root.closest('.product') || document;
    const form = productContainer.querySelector('form[data-product-form]');
    if (!form) return;

    const groups = Array.from(root.querySelectorAll('[data-rmds-existing-option]'));
    const variants = Array.from(root.querySelectorAll('[data-rmds-existing-variant]'));

    function matchingVariant() {
      if (!variants.length) return null;
      return variants.find((variant) => groups.every((group) => {
        const pos = Number(group.dataset.optionPosition || 0);
        return !pos || variant.getAttribute(`data-option-${pos}`) === group.dataset.selectedValue;
      })) || variants[0];
    }

    function sync() {
      const variant = matchingVariant();
      if (!variant) return;

      const idInput = form.querySelector('[name="id"]');
      if (idInput) {
        idInput.value = variant.dataset.id;
        idInput.dispatchEvent(new Event('change', { bubbles: true }));
      }

      const mediaId = variant.dataset.mediaId;
      if (mediaId) {
        const thumb = productContainer.querySelector(`.product__media-container.above-mobile [data-thumbnail-id="${mediaId}"]`)
          || productContainer.querySelector(`[data-thumbnail-id="${mediaId}"]`);
        if (thumb) thumb.click();
      }

      const available = variant.dataset.available === 'true';
      const button = form.querySelector('[data-add-to-cart]');
      if (button) {
        button.disabled = !available;
        button.setAttribute('aria-disabled', available ? 'false' : 'true');
      }
    }

    groups.forEach((group) => {
      const optionButtons = Array.from(group.querySelectorAll('[data-rmds-existing-option-value]'));
      if (optionButtons.length && !optionButtons.some((button) => button.dataset.rmdsExistingOptionValue === group.dataset.selectedValue)) {
        group.dataset.selectedValue = optionButtons[0].dataset.rmdsExistingOptionValue || '';
        optionButtons.forEach((button) => button.setAttribute('aria-pressed', button === optionButtons[0] ? 'true' : 'false'));
        const initialLabel = group.querySelector('[data-rmds-existing-option-label]');
        if (initialLabel) initialLabel.textContent = group.dataset.selectedValue;
        const initialNativeInput = group.querySelector('[data-rmds-existing-native-option]');
        if (initialNativeInput) initialNativeInput.value = group.dataset.selectedValue;
      }
      optionButtons.forEach((button) => {
        button.addEventListener('click', () => {
          group.dataset.selectedValue = button.dataset.rmdsExistingOptionValue || '';
          group.querySelectorAll('[data-rmds-existing-option-value]').forEach((item) => {
            item.setAttribute('aria-pressed', item === button ? 'true' : 'false');
          });
          const label = group.querySelector('[data-rmds-existing-option-label]');
          if (label) label.textContent = group.dataset.selectedValue;
          const nativeInput = group.querySelector('[data-rmds-existing-native-option]');
          if (nativeInput) {
            nativeInput.value = group.dataset.selectedValue;
            nativeInput.dispatchEvent(new Event('change', { bubbles: true }));
          }
          sync();
        });
      });
    });

    sync();
  }

  function boot() {
    document.querySelectorAll('[data-rmds-existing-picker]').forEach(init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
})();
